import { render, staticRenderFns } from "./MpSevkiyat.vue?vue&type=template&id=96926f4c&scoped=true"
import script from "./MpSevkiyat.vue?vue&type=script&lang=js"
export * from "./MpSevkiyat.vue?vue&type=script&lang=js"
import style0 from "./MpSevkiyat.vue?vue&type=style&index=0&id=96926f4c&prod&lang=scss&scoped=true"
import style1 from "./MpSevkiyat.vue?vue&type=style&index=1&id=96926f4c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96926f4c",
  null
  
)

export default component.exports